<template>
  <v-card>
    <v-row no-gutters>
      <v-col cols="12" md="5" class="py-0">
        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-text-field
              id="login"
              v-model="username"
              prepend-icon="mdi-account"
              name="login"
              label="User Name"
              type="text"
            ></v-text-field>
            <v-text-field
              id="password"
              v-model="password"
              prepend-icon="mdi-lock"
              :append-icon="passwordIcon"
              name="password"
              label="Password"
              :type="passwordFieldType"
              @click:append.stop="toggleVisibility"
            ></v-text-field>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="success">Admin Login</v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import router from '../router';

export default {
  data() {
    return {
      passwordIcon: 'mdi-eye',
      passwordFieldType: 'password',
      username: '',
      password: ''
    };
  },
  methods: {
    ...mapActions('user', ['login']),
    submit() {
      var creds = {
        username: this.username,
        password: this.password
      };
      this.login(creds).then(() => {
        let redirect = this.$cookies.get('DocLibRedirectUrl');
        if (redirect && redirect !== '/') {
          this.$cookies.remove('DocLibRedirectUrl');
          router.push(redirect);
        } else {
          router.push('/');
        }
      });
    },
    toggleVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password';
      this.passwordIcon =
        this.passwordIcon === 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye';
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  width: 100%;
}
</style>
